import { Link } from "react-router-dom";
import { ArrowLeft, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import logo from "@/assets/logo.png";
import logoDark from "@/assets/logo-dark.png";
import opendeluxeLogo from "@/assets/opendeluxe-logo.png";
import opendeluxeLogoDark from "@/assets/opendeluxe-logo-dark.png";
import PageFooter from "@/components/PageFooter";

const Contact = () => {
  return (
    <div className="min-h-screen bg-gradient-subtle flex flex-col">
      {/* Header */}
      <header className="glass-card border-b border-border/30 sticky top-0 z-10 shadow-elegant">
        <div className="container mx-auto px-6 py-5">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3">
              <img src={logoDark} alt="untabbed.to logo" className="h-8 w-8 dark:hidden" />
              <img src={logo} alt="untabbed.to logo" className="h-8 w-8 hidden dark:block" />
              <h1 className="text-3xl font-display font-bold text-black dark:text-white tracking-tight">
                untabbed.to
              </h1>
            </Link>
            <Link to="/">
              <Button variant="outline" size="sm">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Back
              </Button>
            </Link>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-6 py-12 flex-1 max-w-4xl">
        <div className="glass-card shadow-card p-8 rounded-lg">
          <h2 className="text-3xl font-display font-bold text-foreground mb-6">Contact Us</h2>
          
          <div className="space-y-8 text-foreground">
            <section>
              <p className="text-muted-foreground leading-relaxed text-lg mb-8">
                Have a question, suggestion, or just want to say hello? We'd love to hear from you!
              </p>
            </section>

            <section className="bg-gradient-card p-8 rounded-lg shadow-glossy">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-primary/10 rounded-lg">
                  <Mail className="h-8 w-8 text-primary" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Email</h3>
                  <p className="text-muted-foreground mb-3">
                    For general inquiries, support, or feedback, please reach out to us at:
                  </p>
                  <a 
                    href="mailto:contact@opendeluxe.com" 
                    className="text-2xl font-display font-semibold text-primary hover:text-primary-glow transition-colors inline-flex items-center gap-2"
                  >
                    contact@opendeluxe.com
                  </a>
                </div>
              </div>
            </section>

            <section className="bg-muted/30 p-6 rounded-lg border border-border/50">
              <h3 className="text-lg font-semibold mb-3">Response Time</h3>
              <p className="text-muted-foreground leading-relaxed">
                We aim to respond to all inquiries within 24-48 hours during business days. 
                Thank you for your patience!
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-4">What Can We Help You With?</h3>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start gap-2">
                  <span className="text-primary mt-1">•</span>
                  <span>Technical support and bug reports</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary mt-1">•</span>
                  <span>Feature requests and suggestions</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary mt-1">•</span>
                  <span>Business inquiries and partnerships</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary mt-1">•</span>
                  <span>General questions about untabbed.to</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary mt-1">•</span>
                  <span>Data protection and privacy concerns</span>
                </li>
              </ul>
            </section>
          </div>

          {/* Powered by OpenDeluxe Ventures */}
          <div className="mt-12 pt-8 border-t border-border/30">
            <div className="flex flex-col items-center gap-3">
              <p className="text-sm text-muted-foreground">Powered by</p>
              <a
                href="https://opendeluxe.com"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-opacity hover:opacity-80 flex items-end gap-2"
              >
                <img src={opendeluxeLogoDark} alt="OpenDeluxe" className="h-12 w-auto dark:hidden" />
                <img src={opendeluxeLogo} alt="OpenDeluxe" className="h-12 w-auto hidden dark:block" />
                <span className="text-2xl font-bold mb-3" style={{ color: '#a855f7' }}>ventures</span>
              </a>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <PageFooter />
    </div>
  );
};

export default Contact;
